import React from 'react';
import PropTypes from 'prop-types';

const WMLogo = (props) => (
	<a
		href={ props.href || '/home' }
		aria-label="Go to WorkMarket Home"
	>
		<img
			id="adp-wm-logo"
			src={ props.logo }
			alt="WorkMarket logo"
			data-attr-id="app-logo"
			style={ {
				width: 140,
				height: 33,
				marginTop: 4,
				marginLeft: '1rem',
			} }
		/>
	</a>
);

WMLogo.propTypes = {
	logo: PropTypes.string,
	href: PropTypes.string,
};

export default WMLogo;


// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/mainNav/components/WaypointShellNav/WMLogo.js